// removed by extract-text-webpack-plugin
module.exports = {"wrap-news-letter-register-custom":"wrap-news-letter-register-custom","title-black":"title-black","news-letter-description":"news-letter-description","label-for-title":"label-for-title","has-value":"has-value","wrap-input":"wrap-input","news-letter-input":"news-letter-input","news-letter-button":"news-letter-button"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-footer/_NewsRegister.scss
// module id = ./components/layouts/master/sub-footer/_NewsRegister.scss
// module chunks = 0